/** @file Entries of an animation's per-entity timeline record in compiled index order (R12-01). */

/**
 * `Object.entries(record)` sorted by each key's compiled index (bones in hierarchy order, slots in setup draw order,
 * IK by `order`, attachments by name), so an animation's timelines come out in one order whatever order its keys were
 * written or restored in. A key missing from `index` sorts first; its requireCompiledIndex then names it.
 */
export function byCompiledIndex<T>(record: Readonly<Record<string, T>>, index: ReadonlyMap<string, number>): [string, T][] {
  return Object.entries(record).sort(([a], [b]) => (index.get(a) ?? -1) - (index.get(b) ?? -1));
}
